"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M8 15.73C9.47 14.06 11.6 13 14 13s4.53 1.06 6 2.73V4H8zM14 5c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm10 5c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3m0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m6-5H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-9.31 14c.95-.63 2.09-1 3.31-1s2.36.37 3.31 1zm9.31-.27C18.53 14.06 16.4 13 14 13s-4.53 1.06-6 2.73V4h12z"
}, "1")], 'SwitchAccountTwoTone');